import React, { FC, useState, useEffect } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { InputSelect } from '@wajeez-web/components/ui';
import { CommonModalProps } from './Types';

interface AssignPlansModalProps extends CommonModalProps<unknown> {
  allPlans: { id: number; name: string }[];
  contentEntityplans: number[];
  setContentEntityplans: React.Dispatch<React.SetStateAction<number[]>>;
}

const AssignPlansModal: FC<AssignPlansModalProps> = ({
  allPlans,
  isOpen,
  onClose,
  onSubmit,
  contentEntityplans = [],
  setContentEntityplans,
}) => {
  const [plans, setplans] = useState<{ value: number; label: string }[]>([]);
  useEffect(() => {
    setplans(
      allPlans.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    );
  }, [allPlans]);

  return (
    <Modal
      onSubmit={onSubmit}
      title={'Assign Plans'}
      open={isOpen}
      onClose={onClose}
    >
      <div className="flex space-s-2">
        <div className="w-full">
          {' '}
          <InputSelect
            isMulti={true}
            name={'Plans'}
            value={plans.filter((ele) =>
              contentEntityplans.includes(ele.value)
            )}
            onChange={(name, value: any) =>
              setContentEntityplans(
                value.map((ele: { value: number }) => ele.value)
              )
            }
            options={plans}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AssignPlansModal;
